import { DatePicker, Select } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

export interface IReportQuery {
  startDate?: string;
  endDate?: string;
  classStatus?: "cancelled" | "reschedule" | "ontime" |"delay";
  course?: string;
  lesson?: string;
  batch?: string;
  teacher?: string;
  center?:string;
}

interface Option {
  label: string;
  value: string;
}

interface Props {
  query: IReportQuery;
  setQuery: (query: Partial<IReportQuery>) => void;

  teachers?: Option[];
  courses: Option[];
  lessons?: Option[];
  batches?: Option[];
  centers?: Option[];

  onPrint?: () => void;
}

export default function ReportFilters({
  query,
  setQuery,
  teachers,
  courses,
  lessons,
  batches,
  onPrint,
  centers
}: Props) {
  return (
    <div
      style={{
        overflowX: "auto",
        width: "100%",
        background: "rgba(0,0,0,0.02)",
        borderRadius: "0.5em",
        marginBottom: "1em",
      }}
    >

      <div className="flex w-full gap-5 overflow-x-auto">
        <div className="flex-1 min-w-[180px] flex-shrink-0">
          <Select
            showSearch
            allowClear
            className="w-full"
            placeholder="Select Teacher"
            value={query.teacher || undefined}
            options={teachers}
            onChange={(value) => setQuery({ teacher: value })}
            onClear={() => setQuery({ teacher: "" })}
            filterOption={(input, option) =>
              option?.label
                ?.toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </div>
        <div className="flex-1 min-w-[180px] flex-shrink-0">
          <Select
            showSearch
            allowClear
            className="w-full"
            placeholder="Select Center"
            value={query.center || undefined}
            options={centers}
            onChange={(value) => setQuery({ center: value })}
            onClear={() => setQuery({ center: "" })}
            filterOption={(input, option) =>
              option?.label
                ?.toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </div>
        <div className="flex-1 min-w-[180px] flex-shrink-0">
          <Select
            showSearch
            allowClear
            className="w-full"
            placeholder="Select Course"
            value={query.course || undefined}
            options={(courses || []).map((course) => ({
              label: `${course.value} - ${course.label}`,
              value: course.value,
            }))}
            onChange={(value) =>
              setQuery({
                course: value,
                lesson: "",
              })
            }
            onClear={() =>
              setQuery({
                course: "",
                lesson: "",
              })
            }
            filterOption={(input, option) =>
              option?.label
                ?.toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </div>
        <div className="flex-1 min-w-[180px] flex-shrink-0">
          <Select
            showSearch
            allowClear
            className="w-full"
            placeholder="Select Lesson"
            value={query.lesson || undefined}
            options={lessons}
            onChange={(value) => setQuery({ lesson: value })}
            onClear={() => setQuery({ lesson: "" })}
            filterOption={(input, option) =>
              option?.label
                ?.toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </div>
        <div className="flex-1 min-w-[180px] flex-shrink-0">
          <Select
            className="w-full"
            placeholder="Select Status"
            value={query.classStatus || undefined}
            allowClear
            onChange={(value) =>
              setQuery({
                classStatus: value,
              })
            }
            onClear={() =>
              setQuery({
                classStatus: undefined,
              })
            }
            options={[
              {
                label: "Cancelled",
                value: "cancelled",
              },
              {
                label: "Rescheduled",
                value: "reschedule",
              },
              {
                label: "On Time",
                value: "ontime",
              },
              {
                label: "Delayed",
                value: "delay",
              },
            ]}
          />
        </div>
        <div className="flex-1 min-w-[180px] flex-shrink-0">
          <RangePicker
            className="w-full"
            value={[
              query.startDate ? dayjs(query.startDate) : null,
              query.endDate ? dayjs(query.endDate) : null,
            ]}
            onChange={(dates) => {
              setQuery({
                startDate: dates?.[0]?.format("YYYY-MM-DD"),
                endDate: dates?.[1]?.format("YYYY-MM-DD"),
              });
            }}
          />
        </div>
      </div>
    </div>
  );
}
